<ng-container *ngIf="!eventService.loadEventTournaments;else loading">
  <div style="margin:10px 0;" *ngFor="let tournament of (eventService.eventTournaments|async)?.data">

    <div class="col-sm-4">
      <a class="tournament-block" href="https://www.gbarena.com/tournaments/{{tournament.code}}"
         style="width:100%">
        <div class="cover" [ngStyle]="{'background-image': 'url('+tournament.cover_picture+')'}">
        </div>
        <div class="text">
          <h1>{{tournament.name}}</h1>


          <p style="margin: 10px 0;">
            <i class="icon-calendar"></i>
            {{globalService.Date(tournament.start_at)}}
          </p>
          <p>
            <i class="icon-clock"></i>
            {{globalService.Time(tournament.start_at)}}
          </p>
          <div class="winners_block">
            <div class="winner_wrapper" *ngFor="let winner of tournament.winners|orderBy:'rank'">
              <p>{{winner.rank}}<i class="icon-award"></i> <img src="{{winner.participant_avatar}}"/>{{winner.participant_name|truncate:10}}
              </p>
            </div>
          </div>
          <div class="status" style="margin-top:auto;">
            <div class="icon"
                 [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress'}"></div>
            <p>{{tournament.status}}</p>
          </div>
        </div>


      </a>
    </div>
  </div>
  <div class="big_block points" *ngIf="(eventService.eventTournaments|async)?.data?.length==0">
    <div class="content text-center">
      <p>No Tournaments yet.</p>
    </div>
  </div>
</ng-container>
<ng-template #loading>
  <app-loading-indicator></app-loading-indicator>
</ng-template>
